import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { BulkCreateQualificationsService } from '../bulk-create-qualifications.service';

@Component({
  selector: 'wilson-bulk-create-qualifications-trigger',
  standalone: true,
  imports: [NzButtonModule, NzTooltipModule, TranslatePipe],
  templateUrl: './bulk-create-qualifications-trigger.component.html',
  styleUrl: './bulk-create-qualifications-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkCreateQualificationsTriggerComponent {
  private readonly bulkCreateQualificationsService = inject(
    BulkCreateQualificationsService,
  );

  public can = inject(AbilityServiceSignal).can;
  public readonly RoleAction = RoleAction;
  public readonly RolePermissionSubject = RolePermissionSubject;

  public showBulkCreateDrawer(): void {
    this.bulkCreateQualificationsService.setBulkCreateDrawerVisible(true);
  }
}
